import { render, staticRenderFns } from "./radarPart.vue?vue&type=template&id=9b24ceec&scoped=true&"
import script from "./radarPart.vue?vue&type=script&lang=js&"
export * from "./radarPart.vue?vue&type=script&lang=js&"
import style0 from "./radarPart.vue?vue&type=style&index=0&id=9b24ceec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b24ceec",
  null
  
)

export default component.exports